/* eslint-disable max-len */
export default {
  title: 'Link de pago',
  customerContactDetails: {
    title: 'Soporte al cliente',
  },
  ticket: {
    for: 'Para',
    from: 'De',
    details: 'Ver detalles de pago',
    createAt: 'Link creado el {{date}}, a las {{time}} por ',
    items: {
      quantity: 'CANT.',
    },
    status: {
      PENDING: 'PENDIENTE',
      PAID: 'PAGADO',
      SUBSCRIBED: 'DOMICILIADO',
      SUBSCRIPTION_CANCELED: 'DOMICILIACIÓN CANCELADA',
      PENDING_ACTIVATION: 'DOMICILIACIÓN PENDIENTE',
    },
  },
  subscription: {
    success: {
      title: '¡Domiciliación exitosa!',
      message: 'Tu tarjeta ha sido domiciliada',
      directDebitMessage: 'Tu clabe interbancaria ha sido domiciliada',
    },
    pending: {
      title: 'Domiciliación en proceso',
      message:
        'La domiciliación interbancaria puede tardar hasta 24 horas hábiles. Una vez confirmada, te notificaremos por correo electrónico.',
    },
    canceled: {
      title: 'Domiciliación cancelada',
      message: 'El cargo domiciliado a tu tarjeta ha sido cancelado',
    },
  },
  payment: {
    info: {
      title: 'Información',
      name: 'Nombre(s)',
      lastName: 'Apellidos',
      email: 'Correo electrónico',
      phone: 'Número de celular',
      phonePlaceholder: 'Ingresa tu número a 10 dígitos',
    },
    payerAddress: {
      title: 'Dirección tarjeta ',
      address: 'Dirección de la tarjeta ',
      city: 'Ciudad',
      state: 'Estado',
      country: 'País',
      zipCode: 'Código Postal',
    },
    methods: {
      title: 'Forma de pago',
      disclaimer:
        'Al hacer clic en el botón de <0>Pagar</0>, accedo a los <1>Términos y Condiciones</1> y <2>Aviso de Privacidad</2>.',
      disclaimerSubscription:
        'Al hacer clic en el botón de <0>Domiciliar</0>, estoy accediendo a domiciliar este cobro de manera automática a mi tarjeta, ademas accedo a los <1>Términos y Condiciones</1> y <2>Aviso de Privacidad</2>.',
      disclaimerDirectDebitSubscription:
        'Al hacer clic en el botón de <0>Domiciliar</0>, acepto domiciliar mi CLABE para cargos automáticos, ademas accedo a los <1>Términos y Condiciones</1> y <2>Aviso de Privacidad</2>.',
      submit: 'Pagar',
      subscribe: 'Domiciliar',
      card: {
        title: 'Tarjeta',
        name: 'Nombre que aparece en la tarjeta',
        number: 'Número de tarjeta',
        validity: 'Vigencia',
        validityPlaceholder: 'MM/AA',
        cvv: 'CVV',
        zipCode: 'Código Postal',
        verificationCode: 'Código de verificación',
        verifying: 'Verificando',
        enterCode:
          'Para validar tu identidad, hemos hecho un cargo a tu tarjeta. Por favor, <0>ingresa los 3 dígitos correspondientes al monto cobrado</0>. Puedes encontrarlo en tu app bancaria',
        chargeWillBeVoided:
          'Este cobro se realiza como un método de seguridad y se anulará de manera automática.',
        paidWithOyster: 'BP Verificación',
        verify: 'Verificar',
        secure3d: {
          amount: 'Monto',
          info: 'Ya casi terminas.\nTu banco ahora verificará el pago usando 3-D secure',
          redirecting: 'Te estamos redireccionando',
          processing: 'Procesando, espere por favor',
          verifiedBy: 'VERIFIED BY',
        },
      },
      directDebit: {
        title: 'Domiciliación bancaria',
        bankAccount: {
          documentType: 'RFC',
          clabe: 'CLABE interbancaria',
          bank: 'Banco',
        },
        noteInfo:
          'La CLABE que registres debe coincidir con el RFC de tu cuenta en PorCobrar. La validación de esta información puede tardar hasta 24 horas hábiles. Una vez confirmada , te notificaremos por correo electrónico.',
      },
      cash: {
        title: 'Efectivo',
        badge: 'Muy pronto',
        info: 'Crearemos un número de referencia para que deposites el pago en cualquiera de estas tiendas.',
        tooltipCashStoreDetails: 'Para ver mas detalles sobre las tiendas, da click <0>aquí</0>',
      },
      spei: {
        title: 'SPEI',
        limitExceeded: 'Esta transacción excede el límite establecido para pagos con tarjeta.',
        info: 'Crearemos un número de referencia para que deposites el pago de acuerdo a la información bancaria.',
        backTitle: 'Forma de pago SPEI',
        anotherBankTab: {
          title: 'Desde cualquier banco',
          instruction:
            'Ingresa a la sección  de transferencia o pagos a otros bancos y proporciona los siguientes datos.',
          amount: 'Monto',
          beneficiaryName: 'Beneficiario',
          clabe: 'CLABE',
          referenceNumber: 'Referencia',
          bankName: 'Banco',
        },
        dlocal: {
          bbvaBankTab: {
            title: 'Desde BBVA',
            steps: {
              1: 'En el menú “Pagar” selecciona la opción “De servicios”',
              2: 'Ingresa el siguiente Número de convenio CIE:',
              3: 'Ingresa los siguientes datos cuando te los soliciten:',
            },
            cieAgreementNumber: 'Número de convenio CIE:',
            referenceNumber: 'Referencia',
            amount: 'Importe',
          },
        },
      },
    },
    errors: {
      card: {
        title: 'Error',
        unknown: 'Intenta de nuevo',
        confirmation: 'No se pudo procesar el pago, intenta de nuevo',
        redirect3ds: 'No se pudo completar el flujo de 3-D secure, intenta de nuevo',
      },
      cash: {
        unknown: 'Intenta de nuevo',
      },
      OTP100: 'Monto Inválido',
      OTP200: 'Intentos excedidos, intenta de nuevo',
      OTP300: 'Validación expirada',
      spei: { title: 'Error', unknown: 'Solicitud fallida. Por favor intenta de nuevo' },
    },
    success: {
      title: '¡Pago exitoso!',
      message: 'Tu pago se procesó correctamente. Te enviamos un correo de confirmación.',
      goBack: 'Ir al dashboard',
    },
    cashReference: {
      copied: '¡Copiaste el número!',
      instructions: {
        title: 'Instrucciones',
        steps: [
          'Acude al comercio e indica al cajero que quieres realizar un pago para el convenio o servicio detallado <0>aquí</0>.',
          'Escanea el número de referencia',
          'Realiza el pago en efectivo por el monto deseado más la comisión del comercio',
          '¡Listo!',
        ],
      },
      emailSentConfirmation: 'Te enviamos un correo con esta información.',
      expirationDate: 'Esta referencia de pago sólo es válida hasta el {{date}}.',
      payWithCardButton: 'Pagar con tarjeta',
      referenceNumber: 'Número de referencia',
      expirationDateMessage:
        'Esta referencia tiene una vigencia de 48 horas y sólo podrás utilizarla una vez.',
    },
    spei: {
      businessName: 'Información del comercio',
      copied: '¡Copiado!',
      clabe: 'CLABE',
      concept: 'Concepto',
      bank: 'Banco',
    },
  },
};
